<template>
  <section id="topics" class="section section-observed topic-section cms-layout-hero">
    <p v-if="front.pageSubtitle" class="hero-layout-subtitle">{{ front.pageSubtitle }}</p>

    <div v-if="highlightBlocks.length" class="hero-layout-cards">
      <article
        v-for="block in highlightBlocks"
        :key="block.blockId || block.blockCode"
        class="hero-layout-card"
      >
        <BlockRenderer :block="block" />
      </article>
    </div>
    <p v-else class="muted-copy">暂无展示内容</p>

    <CmsEntryDetailPanel v-if="front.selectedCmsEntry" />
  </section>
</template>

<script>
import CmsEntryDetailPanel from '../CmsEntryDetailPanel.vue'
import BlockRenderer from '../blocks/BlockRenderer.vue'

export default {
  name: 'HeroLayout',
  components: { CmsEntryDetailPanel, BlockRenderer },
  inject: ['front'],
  computed: {
    highlightBlocks() {
      return this.front.activeBlocks.slice(0, 3)
    }
  }
}
</script>

<style scoped>
.hero-layout-banner {
  width: 100vw;
  max-width: none;
  margin: -24px calc(50% - 50vw) 32px;
  padding: 56px max(var(--content-pad), calc((100vw - var(--content-max)) / 2)) 48px;
  background: linear-gradient(135deg, var(--primary-deep) 0%, var(--primary) 100%);
  color: #fff;
}

.hero-layout-banner .section-kicker {
  color: var(--gold);
}

.hero-layout-banner h1 {
  margin: 0;
  max-width: 760px;
  font-size: clamp(32px, 5vw, 48px);
  line-height: 1.2;
}

.hero-layout-subtitle {
  margin: 0 0 24px;
  max-width: 680px;
  color: var(--subtle);
  font-size: 17px;
  line-height: 1.8;
}

.hero-layout-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.hero-layout-card {
  min-height: 220px;
  border: 1px solid var(--border);
  border-top: 3px solid var(--gold);
  border-radius: var(--front-radius);
  padding: 20px;
  background: #fff;
}

@media (max-width: 900px) {
  .hero-layout-cards {
    grid-template-columns: 1fr;
  }
}
</style>
